import { downloadDailyBalancePdf } from './dailyBalancePdf';

export const downloadDailyGlobalBalancePdf = (options) =>
  downloadDailyBalancePdf({
    ...options,
    blockLabel: 'Todas las variedades',
    filenamePrefix: 'balance-diario-global',
    reportTitle: 'BALANCE DIARIO GLOBAL',
  });
